<template>
    <div class="container">
        <div class="container-left">
            <div class="header">
                门头店铺设计助手
            </div>
            <div class="nav">
                <NavHome />
            </div>
        </div>
        <div class="container-right">
            <div class="right-end">
                <div v-if="isLoggedIn" class="right-box">
                    <img class="right-icon" src="../images/jiao.png" alt="">
                    <div class="right-title">剩余 <div class="right-length">{{ userPoints }}</div>积分 </div>
                    <button class="right-btn" @click="goToRecharge">充值</button>
                </div>
                <div v-else class="right-login-register">
                    <div class="login" @click="openDialog('login')">登录</div>
                    <div class="reain" @click="openDialog('register')">注册</div>
                </div>
            </div>
            <div class="content">
                <!-- 这里会显示当前路由对应的组件 -->
                <RouterView />
            </div>
            <!-- 用户信息展示区域 -->
            <div class="user-info-container">
                <div v-if="isLoggedIn" class="user-info" @click="goToUserProfile">
                    <img class="user-avatar" src="../images/default.png" alt="用户头像">
                    <div class="user-details">
                        <div class="user-account">{{ store.getters.userInfo?.username || '未知用户' }}</div>
                        <div class="user-phone">{{ store.getters.userInfo?.phone || '未知手机号' }}</div>
                    </div>
                    <!-- <img class="arrow-icon" src="../images/right-arrow.png" alt="右箭头"> -->
                </div>
                <div v-else class="login-prompt" @click="openDialog('login')">
                    立即登录
                </div>
            </div>
        </div>
    </div>
    <el-dialog v-model="dialogVisible" class="login-dialog" width="500" :before-close="handleClose">
        <LoginRegister ref="loginRegisterRef" :defaultTab="defaultTab" @login-success="handleLoginSuccess" />
    </el-dialog>
    
    <!-- 充值弹窗 -->
    <el-dialog v-model="rechargeDialogVisible" title="充值" width="300px" :before-close="closeRechargeDialog" class="recharge-dialog-container">
        <div class="recharge-dialog">
            <div class="amount-options">
                <div class="amount-item" @click="selectAmount(10)">10元</div>
                <div class="amount-item" @click="selectAmount(30)">30元</div>
                <div class="amount-item" @click="selectAmount(50)">50元</div>
                <div class="amount-item" @click="selectAmount(100)">100元</div>
            </div>
            <div class="custom-amount">
                <el-input v-model="customAmount" placeholder="自定义金额" type="number" />
                <el-button type="primary" @click="rechargeCustomAmount" class="recharge-btn">充值</el-button>
            </div>
        </div>
    </el-dialog>
    
    <!-- 用户信息弹窗 -->
    <el-dialog v-model="userInfoDialogVisible" width="300px" :before-close="closeUserInfoDialog" class="user-info-dialog">
        <div class="user-info-content">
            <div class="user-info-header">
                <img class="user-avatar-large" src="../images/default.png" alt="用户头像">
                <div class="user-basic-info">
                    <div class="user-name">{{ store.getters.userInfo?.username || '未知用户' }}</div>
                    <div class="user-id">ID: {{ store.getters.userInfo?.id || '未知' }}</div>
                </div>
            </div>
            <div class="user-info-details">
                <div class="info-item">
                    <span class="label">手机号:</span>
                    <span class="value">{{ store.getters.userInfo?.phone || '未绑定' }}</span>
                </div>
                <div class="info-item">
                    <span class="label">积分:</span>
                    <span class="value">{{ store.getters.userInfo?.points || store.getters.userInfo?.credit || 0 }}</span>
                </div>
                <div class="info-item">
                    <span class="label">注册时间:</span>
                    <span class="value">{{ formatDateTime(store.getters.userInfo?.createdAt) }}</span>
                </div>
            </div>
            <div class="user-actions">
                <el-button type="danger" @click="handleLogout" class="logout-btn">退出登录</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import NavHome from '@/components/navHome.vue';
import { ref, nextTick, computed, provide } from 'vue';
import { useStore } from 'vuex';
import LoginRegister from './LoginRegister.vue';
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';

const store = useStore();
const router = useRouter();
const dialogVisible = ref(false);
const rechargeDialogVisible = ref(false);
const userInfoDialogVisible = ref(false);
const defaultTab = ref('login');
const loginRegisterRef = ref(null);
const customAmount = ref('');

// 计算属性：判断用户是否已登录
const isLoggedIn = computed(() => store.getters.isLoggedIn);

// 计算属性：获取用户积分（假设积分存储在userInfo中）
const userPoints = computed(() => {
    // 这里需要根据实际的API响应结构调整
    // 假设积分存储在userInfo.points或userInfo.credit中
    return store.getters.userInfo?.points || store.getters.userInfo?.credit || 0;
});

// 打开弹窗并设置默认标签
const openDialog = (tab) => {
    defaultTab.value = tab;
    dialogVisible.value = true;

    // 确保组件已经渲染后再切换标签
    nextTick(() => {
        if (loginRegisterRef.value) {
            loginRegisterRef.value.switchTab(tab);
        }
    });
};

// 提供openLoginDialog函数给子组件使用
provide('openLoginDialog', openDialog);

// 处理登录成功
const handleLoginSuccess = () => {
    dialogVisible.value = false;
    // 登录成功后会自动通过路由守卫获取用户信息
};

// 处理关闭弹窗
const handleClose = (done) => {
    // 可以在这里添加关闭前的确认逻辑
    done();
};

// 打开充值弹窗
const openRechargeDialog = () => {
    rechargeDialogVisible.value = true;
};

// 关闭充值弹窗
const closeRechargeDialog = () => {
    rechargeDialogVisible.value = false;
    customAmount.value = '';
};

// 选择充值金额
const selectAmount = async (amount) => {
    try {
        await store.dispatch('recharge', amount);
        ElMessage({
            message: `充值${amount}元成功`,
            type: 'success',
            duration: 3000
        });
        console.log(`充值${amount}元成功`);
    } catch (error) {
        ElMessage({
            message: '充值失败: ' + (error.response?.data?.message || error.message || '未知错误'),
            type: 'error',
            duration: 3000
        });
    }
    closeRechargeDialog();
};

// 自定义充值金额
const rechargeCustomAmount = async () => {
    const amount = parseFloat(customAmount.value);
    if (isNaN(amount) || amount <= 0) {
        ElMessage({
            message: '请输入有效的充值金额',
            type: 'warning',
            duration: 3000
        });
        return;
    }
    
    try {
        await store.dispatch('recharge', amount);
        ElMessage({
            message: `充值${amount}元成功`,
            type: 'success',
            duration: 3000
        });
        console.log(`充值${amount}元成功`);
    } catch (error) {
        ElMessage({
            message: '充值失败: ' + (error.response?.data?.message || error.message || '未知错误'),
            type: 'error',
            duration: 3000
        });
    }
    closeRechargeDialog();
};

// 跳转到充值页面
const goToRecharge = () => {
    router.push('/recharge');
};

// 跳转到用户个人资料页面
const goToUserProfile = () => {
    // 打开用户信息弹窗
    userInfoDialogVisible.value = true;
};

// 关闭用户信息弹窗
const closeUserInfoDialog = () => {
    userInfoDialogVisible.value = false;
};

// 格式化日期时间
const formatDateTime = (dateString) => {
    if (!dateString) return '未知';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '未知';
    
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
};

// 退出登录
const handleLogout = async () => {
    try {
        await store.dispatch('logout');
        closeUserInfoDialog();
        ElMessage({
            message: '退出登录成功',
            type: 'success',
            duration: 3000
        });
        console.log('退出登录成功');
    } catch (error) {
        ElMessage({
            message: '退出登录失败: ' + (error.response?.data?.message || error.message || '未知错误'),
            type: 'error',
            duration: 3000
        });
    }
};
</script>

<style>
body {
    padding: 0 !important;
    margin: 0 !important;
}
</style>

<style scoped lang="less">
.container {
    width: 100vw;
    height: 100vh;
    background: #000;
    color: #fff;
    display: flex;

    &-left {
        width: 225px;
        height: 100%;
        background: linear-gradient(270deg, #0E0F0F 0%, #3A3B3B 100%);
        border-radius: 0px 0px 0px 0px;
        padding: 16px 0 16px 24px;
        box-sizing: border-box;

        .header {
            font-family: MFXiHeiNoncommercial, MFXiHeiNoncommercial;
            font-weight: 400;
            font-size: 24px;
            color: #FFFFFF;
        }
    }

    &-right {
        flex: 1;
        padding: 16px;
        box-sizing: border-box;

        .right-box {
            width: 196px;
            height: 38px;
            background: #292929;
            border-radius: 8px 8px 8px 8px;
            display: flex;
            align-items: center;
        }

        .right-length {
            font-family: Arial, Arial;
            font-weight: bold;
            font-size: 14px;
            color: #5EFF00;
        }

        .right-title {
            display: flex;
            align-items: center;
            font-family: Arial, Arial;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
        }

        .right-btn {
            width: 48px;
            height: 26px;
            background: rgba(0, 251, 255, 0.2);
            border-radius: 18px 18px 18px 18px;
            font-family: Arial, Arial;
            font-weight: normal;
            font-size: 12px;
            color: #5EFF00;
            border: none;
            margin: 0 8px;
        }

        .right-icon {
            width: 16px;
            height: 16px;
            margin-right: 8px;
            margin-left: 16px;
        }

        .right-login-register {
            display: flex;
            justify-content: end;
            font-family: Arial, Arial;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            cursor: pointer;

            .login {
                margin-right: 24px;

                &:hover {
                    color: #5EFF00;
                }
            }

            .reain {
                margin-right: 16px;

                &:hover {
                    color: #5EFF00;
                }
            }
        }

        .right-end {
            display: flex;
            justify-content: end;
        }
    }
    
    // 用户信息展示区域
    .user-info-container {
        position: fixed;
        bottom: 20px;
        left: 20px;
        width: 200px;
        
        .user-info {
            display: flex;
            align-items: center;
            padding: 10px;
            background: #2B2C2C;
            border-radius: 8px;
            cursor: pointer;
            
            .user-avatar {
                width: 40px;
                height: 40px;
                border-radius: 50%;
                margin-right: 10px;
            }
            
            .user-details {
                flex: 1;
                
                .user-account {
                    font-family: Arial, Arial;
                    font-weight: bold;
                    font-size: 14px;
                    color: #FFFFFF;
                    margin-bottom: 4px;
                }
                
                .user-phone {
                    font-family: Arial, Arial;
                    font-weight: normal;
                    font-size: 12px;
                    color: #AAAAAA;
                }
            }
            
            .arrow-icon {
                width: 16px;
                height: 16px;
            }
        }
        
        .login-prompt {
            padding: 10px;
            background: #2B2C2C;
            border-radius: 8px;
            font-family: Arial, Arial;
            font-weight: bold;
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
            cursor: pointer;
            
            &:hover {
                background: #5EFF00;
                color: #000;
            }
        }
    }
}

.nav {
    margin-top: 20px;
}

.content {
    margin-top: 20px;
    margin-left: 20px;
}

/* 响应式设计 */
@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
    
    &-left {
      width: 100%;
      height: auto;
      padding: 16px;
    }
    
    &-right {
      padding: 16px 10px;
    }
  }
  
  .user-info-container {
    position: static;
    width: 100%;
    padding: 0 16px;
    
    .user-info {
      width: 100%;
    }
  }
  
  .right-login-register {
    justify-content: center;
    
    .login {
      margin-right: 16px;
    }
    
    .reain {
      margin-right: 8px;
    }
  }
  
  .right-end {
    justify-content: center;
  }
}
</style>

<style lang="less">
// 充值弹窗样式
.recharge-dialog {
    padding: 30px;
    background: #000000;
    color: #FFFFFF;
    
    .amount-options {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
        margin-bottom: 25px;
        
        .amount-item {
            padding: 20px;
            text-align: center;
            background: #1A1A1A;
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.3s;
            font-size: 18px;
            font-weight: bold;
            color: #FFFFFF;
            border: 2px solid transparent;
            
            &:hover {
                background: #5EFF00;
                color: #000;
                border-color: #5EFF00;
            }
        }
    }
    
    .custom-amount {
        display: flex;
        flex-direction: column;
        gap: 15px;
        
        .recharge-btn {
            background: #5EFF00;
            border-color: #5EFF00;
            color: #000;
            height: 45px;
            font-size: 16px;
            font-weight: bold;
            border-radius: 8px;
        }
    }
}

// 用户信息弹窗样式
.user-info-dialog {
    padding: 30px;
    background: #000000;
    color: #FFFFFF;
    
    .user-info-header {
        display: flex;
        align-items: center;
        padding-bottom: 25px;
        border-bottom: 1px solid #333;
        
        .user-avatar-large {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            margin-right: 20px;
            border: 2px solid #5EFF00;
        }
        
        .user-basic-info {
            .user-name {
                font-family: 'Microsoft YaHei', Arial, sans-serif;
                font-weight: bold;
                font-size: 22px;
                color: #333;
                margin-bottom: 8px;
            }
            
            .user-id {
                font-family: 'Microsoft YaHei', Arial, sans-serif;
                font-weight: normal;
                font-size: 16px;
                color: #AAAAAA;
            }
        }
    }
    
    .user-info-details {
        padding: 25px 0;
        
        .info-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 18px;
            padding: 12px 15px;
            background: #1A1A1A;
            border-radius: 8px;
            
            .label {
                font-family: 'Microsoft YaHei', Arial, sans-serif;
                font-weight: normal;
                font-size: 16px;
                color: #CCCCCC;
            }
            
            .value {
                font-family: 'Microsoft YaHei', Arial, sans-serif;
                font-weight: bold;
                font-size: 16px;
                color: #5EFF00;
            }
        }
    }
    
    .user-actions {
        .logout-btn {
            width: 100%;
            height: 45px;
            background: #FF4D4D;
            border-color: #FF4D4D;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: bold;
            border-radius: 8px;
            
            &:hover {
                background: #FF6666;
                border-color: #FF6666;
            }
        }
    }
}

// 全局弹窗样式
.login-dialog {
    .el-dialog {
        background: #000 !important;
        border-radius: 16px;
        border: 2px solid #333;
        
        .el-dialog__header {
            padding: 0;
            margin-right: 0;
            display: none; // 隐藏默认标题栏
        }
        
        .el-dialog__body {
            padding: 0;
            background: #000;
            border-radius: 16px;
        }
        
        .el-dialog__footer {
            display: none;
        }
    }
    
    .el-overlay {
        background-color: rgba(0, 0, 0, 0.9) !important;
        
        .el-overlay-dialog {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

// 用户信息弹窗样式
.user-info-dialog {
    .el-dialog {
        background: #000 !important;
        border-radius: 16px;
        border: 2px solid #333;
        
        .el-dialog__header {
            padding: 0;
            margin-right: 0;
            display: none; // 隐藏默认标题栏
        }
        
        .el-dialog__body {
            padding: 0;
            background: #000;
            border-radius: 16px;
            color: #FFFFFF;
        }
        
        .el-dialog__footer {
            display: none;
        }
    }
}

// 充值弹窗样式
.recharge-dialog-container {
    .el-dialog {
        background: #000 !important;
        border-radius: 16px;
        border: 2px solid #333;
        
        .el-dialog__header {
            padding: 0;
            margin-right: 0;
            display: none; // 隐藏默认标题栏
        }
        
        .el-dialog__body {
            padding: 0;
            background: #000;
            border-radius: 16px;
            color: #FFFFFF;
        }
        
        .el-dialog__footer {
            display: none;
        }
    }
}
</style>